/* Copyright 2026 EXOLOX, INC. Focused/in-view machining preview. */
(() => {
  const setup = () => document.querySelectorAll('[data-orbit-cnc-video]').forEach(video => {
    if (video.dataset.motionReady) return;
    video.dataset.motionReady = 'true';
    const item = video.closest('[data-orbit-item]');
    const button = item.querySelector('[data-orbit-cnc-toggle]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, userPaused = reduced.matches;
    const update = () => {
      const shouldPlay = visible && item.classList.contains('is-active') && !document.hidden && !userPaused;
      if (shouldPlay) {
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        if (video.paused) video.play().catch(() => { if (item.classList.contains('cnc-motion-playing')) item.classList.remove('cnc-motion-playing'); });
      } else {
        video.pause();
        if ((!visible || !item.classList.contains('is-active') || reduced.matches) && item.classList.contains('cnc-motion-playing')) item.classList.remove('cnc-motion-playing');
      }
      button.textContent = userPaused ? 'Play machining' : 'Pause machining';
      button.setAttribute('aria-pressed', String(!userPaused));
    };
    video.addEventListener('playing', () => { if (!item.classList.contains('cnc-motion-playing')) item.classList.add('cnc-motion-playing'); });
    video.addEventListener('error', () => { if (item.classList.contains('cnc-motion-playing')) item.classList.remove('cnc-motion-playing'); });
    button.addEventListener('click', event => { event.stopPropagation(); userPaused = !userPaused; update(); });
    new MutationObserver(update).observe(item, {attributes:true, attributeFilter:['class']});
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, {threshold:.05}).observe(item);
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', () => { userPaused = reduced.matches; update(); });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup,{once:true}); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
